/**
 * @generated SignedSource<<c4a4e92d8ea397bbbec0dd2c4cc629f3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ChangeCoachSavedCreditCardInput = {
  clientMutationId?: string | null | undefined;
};
export type CoachCardInfoFormSaveCoachCreditCardForFutureUsageMutation$variables = {
  input: ChangeCoachSavedCreditCardInput;
};
export type CoachCardInfoFormSaveCoachCreditCardForFutureUsageMutation$data = {
  readonly changeCoachSavedCreditCard: {
    readonly client_secret: string;
  } | null | undefined;
};
export type CoachCardInfoFormSaveCoachCreditCardForFutureUsageMutation = {
  response: CoachCardInfoFormSaveCoachCreditCardForFutureUsageMutation$data;
  variables: CoachCardInfoFormSaveCoachCreditCardForFutureUsageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ChangeCoachSavedCreditCardPayload",
    "kind": "LinkedField",
    "name": "changeCoachSavedCreditCard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "client_secret",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CoachCardInfoFormSaveCoachCreditCardForFutureUsageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CoachCardInfoFormSaveCoachCreditCardForFutureUsageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a212af1b4583b7db0e3871b2ba72628c",
    "id": null,
    "metadata": {},
    "name": "CoachCardInfoFormSaveCoachCreditCardForFutureUsageMutation",
    "operationKind": "mutation",
    "text": "mutation CoachCardInfoFormSaveCoachCreditCardForFutureUsageMutation(\n  $input: ChangeCoachSavedCreditCardInput!\n) {\n  changeCoachSavedCreditCard(input: $input) {\n    client_secret\n  }\n}\n"
  }
};
})();

(node as any).hash = "717e2860f9432c59c6f268f3a636577d";

export default node;
